var map = {
	"./call_dark.svg": 835931,
	"./call_light.svg": 709393,
	"./heart_dark.svg": 134535,
	"./heart_light.svg": 164482,
	"./mental_health_dark.svg": 279443,
	"./mental_health_light.svg": 809305,
	"./perks_dark.svg": 503602,
	"./perks_light.svg": 39722,
	"./question_dark.svg": 355047,
	"./question_light.svg": 59125,
	"./smartphone_dark.svg": 745900,
	"./smartphone_light.svg": 57956,
	"./writing_dark.svg": 437131,
	"./writing_light.svg": 711969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152642;